/*
  Dad Certified - autoplay the first product gallery video.

  Refresh keeps product videos inside an inert <template> within <deferred-media>,
  so the video only loads when the poster is clicked. This injects the first
  gallery video on page load and plays it muted, which the browser autoplay
  policy permits.

  Native controls are left in place on purpose (WCAG 2.2.2 Pause, Stop, Hide -
  auto-playing content longer than five seconds needs a pause mechanism).
  Playback pauses while the video is scrolled out of view.
*/
(function () {
  function boot() {
    var dm = document.querySelector('.product__media-list deferred-media');
    if (!dm || dm.getAttribute('loaded')) return;

    var tpl = dm.querySelector('template');
    if (!tpl || !tpl.content.firstElementChild) return;

    var wrap = document.createElement('div');
    wrap.appendChild(tpl.content.firstElementChild.cloneNode(true));

    var v = wrap.querySelector('video');
    if (!v) return;

    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', 'muted');
    v.setAttribute('playsinline', 'playsinline');
    v.setAttribute('autoplay', 'autoplay');
    v.setAttribute('loop', 'loop');
    v.loop = true;
    v.setAttribute('preload', 'auto');

    dm.setAttribute('loaded', 'true');
    dm.appendChild(v);

    var p = v.play();
    if (p && p.catch) p.catch(function () {});

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              var q = v.play();
              if (q && q.catch) q.catch(function () {});
            } else {
              v.pause();
            }
          }
        },
        { threshold: 0.15 }
      );
      io.observe(v);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
